// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SmartTextareaInput":"bfr_a bha_tx bha_ul bha_wa bha_uc"};